import { render, staticRenderFns } from "./businessDetailService.vue?vue&type=template&id=670cd35b&scoped=true"
import script from "./businessDetailService.vue?vue&type=script&lang=js"
export * from "./businessDetailService.vue?vue&type=script&lang=js"
import style0 from "./businessDetailService.vue?vue&type=style&index=0&id=670cd35b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670cd35b",
  null
  
)

export default component.exports